// Cross-brand publishers list endpoint. Relative to the `ops` base URL, so it
// is used with useAxios({ base: "ops" }) — never inline the path at the call site.
export const PUBLISHERS_ENDPOINT = "/affiliates/v1";

// Not live yet — use-publishers.js falls back to a client-side CSV export
// (rowsToCsvBlob) when this 404s/fails.
export const PUBLISHERS_EXPORT_ENDPOINT = "publishers/v1/export";

export const PUBLISHERS_DEFAULT_LIMIT = 10;

export const PUBLISHERS_CSV_COLUMNS = [
    { label: "Publisher", value: (r) => r.holder_name },
    { label: "Email", value: (r) => r.email },
    { label: "Brand", value: (r) => r.brand },
    { label: "KYC status", value: (r) => r.kyc_status },
    { label: "Payout status", value: (r) => r.payout_status },
    { label: "Earnings pending", value: (r) => r.pending_amount },
    { label: "Invoices paid", value: (r) => `${r.invoices?.paid ?? 0}/${r.invoices?.total ?? 0}` },
    { label: "Last payout", value: (r) => r.last_payout_at || "" }
];

// Publisher details — both the cross-brand list and a brand's Publishers tab open
// this page. `tab` picks KYC or Invoices (the page chooses when omitted); `from` is
// where the breadcrumb leads back to — omit it for the list.
export const PUBLISHER_TABS = [
    { id: "kyc", label: "KYC" },
    { id: "invoices", label: "Invoices" }
];
export const publisherDetailsPath = (publisherId, tab) => `/publishers/details/${publisherId}${tab ? `?tab=${tab}` : ""}`;
export const publisherDetailsState = (publisher, from) => ({ publisher, ...(from && { from }) });
